import { ColumnDef, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";

import { Spinner } from "src/core/components/custom-ui/spinner";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/core/components/ui/table";
import { MappedStakeholder } from "src/core/constants/folder";

type StakeholdersDataTableProps = {
  columns: ColumnDef<MappedStakeholder>[];
  data: MappedStakeholder[];
  isLoading?: boolean;
  onSelectStakeholder?: (stakeholder: MappedStakeholder) => void;
};

export const StakeholdersDataTable = ({
  columns,
  data,
  isLoading = false,
  onSelectStakeholder,
}: StakeholdersDataTableProps) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <Table key={data.length} className="stakeholders-datatable">
      <TableHeader className="stakeholders-datatable-header">
        {table.getHeaderGroups().map((headerGroup) => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map((header) => (
              <TableHead key={header.id}>
                {header.isPlaceholder
                  ? null
                  : flexRender(header.column.columnDef.header, header.getContext())}
              </TableHead>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {isLoading ? (
          <TableRow>
            <TableCell colSpan={columns.length} className="h-24 text-center">
              <div className="flex items-center justify-center">
                <Spinner size="lg" />
              </div>
            </TableCell>
          </TableRow>
        ) : table.getRowModel().rows?.length ? (
          table.getRowModel().rows.map((row) => (
            <TableRow
              className="stakeholders-datatable-row"
              key={row.id}
              data-state={row.getIsSelected() && "selected"}
              onClick={() => {
                onSelectStakeholder?.(row.original);
              }}
            >
              {row.getVisibleCells().map((cell) => (
                <TableCell className="stakeholders-datatable-cell" key={cell.id}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={columns.length} className="stakeholders-no-result"></TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
